export default __webpack_public_path__ + "7db1cedf2a40145732f5618d360bcb36.png";